import React from 'react';

const Input = ({
  label,
  type,
  name,
  placeholder,
  value,
  readOnly,
  error,
  errorText,
  onChange,
  onBlur,
  autoComplete,
  className,
  noPadding,
}) => {
  return (
    <div className={noPadding ? '' : 'mb-2'}>
      <small style={{ textTransform: 'capitalize' }}>{label}</small>
      <input
        type={type}
        name={name}
        value={value}
        placeholder={placeholder}
        readOnly={readOnly}
        className={`form-control form-control-sm ${
          error && 'is-invalid'
        } ${className}`}
        onChange={onChange}
        onBlur={onBlur}
        autoComplete={autoComplete ? autoComplete : 'on'}
      />
      <div className="invalid-feedback">{errorText}</div>
    </div>
  );
};

export default Input;
